import { motion } from 'framer-motion';

export function Logo() {
  return (
    <div className="flex items-center gap-4 group cursor-pointer select-none">
      <div className="relative size-10 flex items-center justify-center">
        {/* The Logo Mark - High-fidelity recreation of the uploaded icon */}
        <motion.div 
          className="relative z-10 size-full"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.2 }}
        >
          <svg 
            viewBox="0 0 100 100" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className="size-full transition-all duration-500"
          >
            {/* Solid Black Background Circle */}
            <circle cx="50" cy="50" r="50" fill="black"/>
            
            {/* 
              Stylized 'a' / loop symbol split by a diagonal gap.
              Recreated using two precise paths to ensure the 'exactly same' look 
              as the uploaded image (Modern, fluid loop).
            */}
            <path 
              d="M36.5 37.5C32.5 42.5 30.5 49 30.5 56C30.5 67 39.5 76 50.5 76C57.5 76 63.5 73 67.5 68.5L36.5 37.5Z" 
              fill="white"
            />
            <path 
              d="M63.5 62.5C67.5 57.5 69.5 51 69.5 44C69.5 33 60.5 24 49.5 24C42.5 24 36.5 27 32.5 31.5L63.5 62.5Z" 
              fill="white"
            />
          </svg>
        </motion.div>
      </div>
      
      <div className="flex flex-col -space-y-0.5">
        <span className="text-base font-bold tracking-[0.15em] uppercase text-foreground group-hover:tracking-[0.2em] transition-all duration-500">
          Aure
        </span>
        <div className="flex items-center gap-1.5">
          <span className="text-[10px] font-bold tracking-[0.4em] uppercase text-muted-foreground/60">
            OS
          </span>
          <div className="h-px w-4 bg-muted-foreground/20 group-hover:w-6 group-hover:bg-primary/40 transition-all duration-500" />
        </div>
      </div>
    </div>
  );
}